import React from 'react'
import NavLink from '../routing/NavLink'
import useKiponosNavigator from '../../hooks/useKiponosNavigator'
import './UserFocus.css'

const UserFocusItem = ({title}) => {
  const {PageKeys} = useKiponosNavigator();
  return (
    <div className='userFocusItem'>
      <div className='userFocusIcon'>
        <NavLink pageKey={PageKeys.MY_PROFILE} customTitle={title} withActiveStyle={false}/>
        <NavLink pageKey={PageKeys.LOGOUT}     withActiveStyle={false} />
      </div>
    </div>
  )
}

export default React.memo(UserFocusItem);